// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pointer-input-icon {
  cursor: pointer;
  opacity: 0.54;
}

.btn-confirm {
  background: rgb(174, 15, 10) !important;
  border-radius: 8px;
  color: #fff;
  font-weight: 800;
}

.mat-picker mat-label {
  max-width: 100% !important;
  display: block !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 20px;
}

.mat-picker input::placeholder {
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 20px;
}

:host ::ng-deep mat-form-field .mat-mdc-form-field-icon-suffix {
  position: absolute !important;
  right: 0 !important;
  top: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/shared/components/datetime-picker-input/datetime-picker-input.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,aAAA;AACF;;AAEA;EACE,uCAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;AACF;;AAEA;EACE,0BAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAKA;EACE,6BAAA;EACA,mBAAA;EACA,iBAAA;AAFF","sourcesContent":[".pointer-input-icon {\n  cursor: pointer;\n  opacity: 0.54;\n}\n\n.btn-confirm {\n  background: rgba(174, 15, 10, 1) !important;\n  border-radius: 8px;\n  color: #fff;\n  font-weight: 800;\n}\n\n.mat-picker mat-label {\n  max-width: 100% !important;\n  display: block !important;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding-right: 20px;\n}\n\n.mat-picker input::placeholder {\n  max-width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding-right: 20px;\n}\n\n// Mesma regra que o `date-picker-input` aplicava globalmente por `::ng-deep` sem\n// `:host` — replicada aqui, já escopada, para este componente não mudar de aparência\n// quando o vazamento foi fechado (ver date-picker-input.component.scss).\n:host ::ng-deep mat-form-field .mat-mdc-form-field-icon-suffix {\n  position: absolute !important;\n  right: 0 !important;\n  top: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
